
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JobWorkReceiptLaborGrid extends Serenity.EntityGrid<JobWorkReceiptLaborRow, any> {
        protected getColumnsKey() { return 'Production.JobWorkReceiptLabor'; }
        protected getDialogType() { return JobWorkReceiptLaborDialog; }
        protected getIdProperty() { return JobWorkReceiptLaborRow.idProperty; }
        protected getInsertPermission() { return JobWorkReceiptLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkReceiptLaborRow.localTextPrefix; }
        protected getService() { return JobWorkReceiptLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}